import React, { useContext, useEffect, useState } from 'react'
import { Formik, Form, Field } from 'formik'
import { FiArrowRight } from 'react-icons/fi'
import { toast } from 'react-toastify'
import { FaEnvelope, FaFingerprint } from 'react-icons/fa'
import { MdOutlinePassword } from 'react-icons/md'
import { startRegistration } from '@simplewebauthn/browser'

import yup from '../../../services/yup'
import { Container, Content } from './styles'
import PasswordTextbox from '../../../components/Form/PasswordTextbox'
import { Button, Textbox } from '../../../components/Form'
import { api, authHeaders } from '../../../services/api'
import Yup from '../../../services/yup'
import { GlobalContext } from '../../../contexts/GlobalContext'

const validationSenha = yup.object({
	senha_anterior: yup.string().required('Informe sua senha atual.'),
	senha: yup.string()
		.when('senha_anterior', {
			is: ref => !!ref,
			then: yup.string().required('Digite uma nova senha').min(6, 'A senha deve conter pelo menos 6 caracteres'),
			otherwise: yup.string().notRequired()
		}),
	senha_confirmacao: yup.string()
		.when('senha', {
			is: ref => !!ref,
			then: yup.string().required('Confirme sua nova senha').oneOf([yup.ref('senha')], 'As senhas não coincidem'),
			otherwise: yup.string().notRequired()
		})
})

const validationEmail = yup.object({
	email: yup.string().email('E-mail inválido').required('Informe sua senha atual.')
})

const initialValues = {
    senha_anterior: '',
    senha: '',
    senha_confirmacao: ''
}

const userAgent = navigator.userAgent

export default function () {
	const { user, reload } = useContext(GlobalContext)

	const [email, setEmail] = useState('')
	const [isEmailAlterado, setIsEmailAlterado] = useState(false)
	const [emailAlterado, setEmailAlterado] = useState(null)
	const [estaRegistrandoBiometria, setEstaRegistrandoBiometria] = useState(false)
	
	async function handleChangePassword(values, { setSubmitting, resetForm }) {
        try {
            const { senha, senha_anterior } = values

            await api.put('usuario', {
                senha,
                senha_anterior
            }, authHeaders())

            setSubmitting(false)

            resetForm()

            toast.success('Os dados foram atualizados.')

			reload()
        } catch (e) {
            toast.error(e.msg || 'Ocorreu um erro ao tentar salvar os dados.')
        }
    }

	async function handleUpdateEmail(values) {
		try {
			const { email: novoEmail } = values

			const body = {
				contato: novoEmail,
				tipo_contato_id: 6,
				pessoa_id: user.pessoa.id
			}

			if (email) {
				await api.put('usuario', { email: novoEmail }, authHeaders())
			} else {
				await api.post('contato', body, authHeaders())
			}

			toast.success('A solicitação de troca de e-mail foi enviada.')

			setIsEmailAlterado(true)

			setEmailAlterado(novoEmail)

			reload()
		} catch (e) {
			toast.error(e.msg)
		}
	}

	async function handleAtivarBiometria(values) {
		try {
			const { email, nome_dispositivo } = values

			if(!email) {
				toast.error('E-mail de acesso não identificado!')
				return
			}

			const options = await api.get(`init-registration`, { 
				withCredentials: true,
				params: { 
					email
				}
			})

			const registrationJSON = await startRegistration(options)

			const verifyData = await api.post('verify-registration', { 
				...registrationJSON, 
				email, 
				nome_dispositivo,
				user_agent: userAgent
			}, {
				withCredentials: true
			})

			if(verifyData.verified) {
				localStorage.setItem('sigas:username', email)

				toast.success('Seu PIN / biometria foi configurado.')

				reload()
			}
		} catch(e) {
			toast.error(e.msg)
		}
	}

	async function handleDesativarBiometria() {
		try {
			if(!email) {
				return
			}

			await api.delete(`desativar_biometria/${user.id}`, authHeaders())

			localStorage.removeItem('sigas:username')

			reload()

			toast.success('A autenticação por PIN / biometria foi desativada neste dispositivo.')
		} catch(e) {
			toast.error(e.message)
		}
	}

	useEffect(() => {
		if (user) {
			setEmail(user.crm || '')
		}
	}, [user])

	const dispositivoJaCadastrado = userAgent === user.biometria?.user_agent

	let nomeSugerido

	if(userAgent.includes('Windows')) {
		nomeSugerido = 'Meu Windows'
	} else if(userAgent.includes('Android')) {
		nomeSugerido = 'Meu Android'
	} else if(userAgent.includes('iPhone')) {
		nomeSugerido = 'Meu iPhone'
	} else if(userAgent.includes('Linux')) {
		nomeSugerido = 'Meu Linux'
	} else if(userAgent.includes('Macintosh')) {
		nomeSugerido = 'Meu MAC'
	} else {
		nomeSugerido = 'Meu dispositivo'
	}

	return (
		 <Container className="px-1 py-1 md:px-8 md:py-4 lg:px-24 lg:py-12">
			<Content className="animated fadeIn bg-white text-slate-800 flex flex-col gap-4">
				<h1 className="text-slate-800 col-span-2">Acesso</h1>

				<Formik
					initialValues={initialValues}
					validationSchema={validationSenha}
					onSubmit={handleChangePassword}
				>
					{({ isSubmitting }) => (
						<Form className="col-span-2 h-fit">
							<div className="p-4 rounded-md border flex flex-col gap-4">
								<h2 className="text-slate-800 text-lg font-medium mx-2 flex gap-2 items-center">
									<MdOutlinePassword size={24} />
									Trocar senha de acesso
								</h2>

								<div className="flex flex-col xl:flex-row">
									<PasswordTextbox name="senha_anterior" label="Senha atual" />

									<PasswordTextbox name="senha" label="Nova senha" />

									<PasswordTextbox name="senha_confirmacao" label="Confirme a nova senha" />

									<div className="mt-4 md:self-end">
										<Button type="submit" loading={isSubmitting} className="w-full md:w-fit">
											<span>Alterar senha</span>
											<FiArrowRight size={18} />
										</Button>
									</div>
								</div>
							</div>
						</Form>
					)}
				</Formik>

				<div className="flex flex-col xl:flex-row gap-4">
					<Formik
						initialValues={{ email }}
						validationSchema={validationEmail}
						onSubmit={handleUpdateEmail}
						enableReinitialize
					>
						{({ isSubmitting }) => (
							<Form className="flex-2 flex flex-col gap-3 h-fit">
								<div className="p-4 rounded-md border flex flex-col gap-4">
									<h2 className="text-slate-800 text-lg font-medium mx-2 flex gap-2 items-center">
										<FaEnvelope size={17} />
										E-mail de acesso
									</h2>

									<p style={{ gridArea: 'info' }} className="mx-2">
										Caso você prefira acessar o SIGAS usando outro e-mail, informe-o abaixo:
									</p>

									<div className="flex flex-col md:flex-row gap-2 md:items-end">
										<Textbox name="email" label="E-mail" />

										<Button type="submit" loading={isSubmitting}>
											<span>Alterar</span>
											<FiArrowRight size={18} />
										</Button>
									</div>

									{(isEmailAlterado || emailAlterado) && (
										<div className="text-center mt-5 col-span-3 bg-yellow-400 rounded-md px-3 py-2 animated flash fast w-fit">
											Você solicitou alteração do e-mail de acesso para <span className="font-bold">{emailAlterado}</span>. Acesse este e-mail e clique no link de confirmação.
										</div>
									)}
								</div>
							</Form>
						)}
					</Formik>

					{/* <div className="p-4 rounded-md border flex flex-col gap-4 flex-1 h-fit">
						<h2 className="text-slate-800 text-lg font-medium mx-2 flex gap-2 items-center">
							<FaFingerprint size={18} />
							Acesso por PIN / impressão digital
						</h2>

						{dispositivoJaCadastrado ? (
							<div className="flex flex-col gap-3">
								<div className="bg-yellow-400 p-2 rounded-md w-fit">
									Você já cadastrou seu PIN / biometria neste dispositivo.
								</div>

								<div 
									className="text-red-500 cursor-pointer mx-1 hover:font-medium" 
									onClick={handleDesativarBiometria}
								>
									Desativar a autenticação por PIN / biometria
								</div>
							</div>
						) : estaRegistrandoBiometria ? (
							<Formik
								onSubmit={handleAtivarBiometria}
								initialValues={{
									email,
									nome_dispositivo: nomeSugerido
								}}
								validationSchema={Yup.object({
									nome_dispositivo: Yup.string().required('Informe um nome para este dispositivo.')
								})}
							>
								{({ isSubmitting }) => (
									<Form className="flex flex-col gap-2">
										<Textbox 
											label="Dê um nome para este dispositivo"
											name="nome_dispositivo"
										/>

										<Field type="hidden" name="email" value={email} />

										<div className="flex">
											<Button 
												onClick={() => { setEstaRegistrandoBiometria(true) }} 
												className="w-full md:w-fit self-center" 
												loading={isSubmitting}
												type="submit"
											>
												<span>Ativar agora</span>
												<FiArrowRight size={18} />
										</Button>
										</div>
									</Form>
								)}
							</Formik>
						) : (
							<>
								<p className="mx-2">Sabia que você pode fazer seu login sem precisar lembrar de senhas? No SIGAS você tem a opção de utilizar sua impressão digital ou código PIN.</p>
								
								<div className="flex">
									<Button onClick={() => { setEstaRegistrandoBiometria(true) }} className="w-full md:w-fit self-center" disabled={dispositivoJaCadastrado}>
										<span>Ativar PIN / biometria</span>
										<FiArrowRight size={18} />
									</Button>
								</div>
							</>
						)}
					</div> */}
				</div>
			</Content>
		</Container>
	)
}
